module.exports = __webpack_public_path__ + "static/media/calendar.f02dbe47.svg";